@if(loaded) {
	<input class="modal-prevent-focus" disabled>

	@if(showBook()) {
		<book
			[class]="!bookHidden ? 'show' : 'hide'"
			[currentNode]="file"
			[currentPage]="page"
			(onClick)="changeSrc($event)"
			(onLoad)="bookLoaded($event)">
		</book>
	}



	@if(_node) {
		<div class="file-wrapper" [ngClass]="showMenu?'menuOpen':''">

			<div class="modal-header">

				<div class="modal-file-title">

					<h1>{{caption}}</h1>

					@if(flags.length>1 && !fallbackDisabled) {
						<div class="i18n-flags">
							<ul>
								@for (flag of flags; track flag.isoCode) {
									<li class="i18n-flag pointer" (click)="openTranslation(flag.isoCode)"
										[class.current]="getIsoCode() === flag.isoCode">
										<img [src]="'assets/flags/'+flag.flag.toLocaleUpperCase()+'@2x.png'" [title]="flag.name"
											style="margin-right:5px;" [alt]="flag.name"/>
									</li>
								}
							</ul>
						</div>
					}
				</div>


				<div class="file-actions">
					@if(file) {
						<file-actions [node]="file" *ngIf="true" [isoCode]="getIsoCode()">
							@if(file.isPDF()) {
								@if(file.viewer !== 'Extern') {
									<div class="file-actions__pagination">
										@if((file.pages && file.pages > 1) || (showBook() && bookPages)){
											<span (click)="pageBack()" class="phb-icon icon--arrow--left-thicker"
												[title]="'title_book_back' | translate:systemLanguage"></span>
										}

										@if(!bookPages && file.pages && file.pages > 1) {
											<div>
												<input class="input-page-nbr" type="number" min="1" [max]="file.pages"
													[(ngModel)]="pageInput" (change)="toSpecificPage()">/{{file.pages}}
											</div>
										}

										@if(bookPages && bookPages.length > 1) {
											<div>
												<input class="input-page-nbr" type="number" min="1" [max]="bookPages.length"
													[(ngModel)]="currentOpenPageInBookInput"
													(change)="toSpecificPage()">/{{bookPages.length}}
											</div>
										}

										@if((file.pages && file.pages > 1) || (showBook() && bookPages)) {
											<span (click)="pageNext()" class="phb-icon icon--arrow--right-thicker"
												[title]="'title_book_next' | translate:systemLanguage"></span>
										}
									</div>
								}

								@if(showBook()) {
									<span (click)="toggleBook()" class="phb-icon icon--book" [title]="'title_book_'+(bookHidden ? 'show' : 'hide') | translate:systemLanguage"></span>
								}
							}
						</file-actions>
					}


				</div>

				<div class="modal-close" (click)="closeModal()">
					<span class="icon--cross2"></span>
				</div>
			</div>


			@if(!fileNotAvailable){
				@if(!showVideoErrorMessage) {
					<div class="file-modal-content" [ngClass]="video?'file-modal-content--video':''">
						@if(translationAvailable) {
							@if(isNormalFileOrWeblink()) {
								@if(!showVirtualFileOfflineWarning) {
									@if(video) {
										<video-player [file]="file" [src]="src"></video-player>
									} @else if (src) {
										<iframe id="iframe-file" [src]="src"></iframe>
									}
								} @else {
									<ng-container *ngTemplateOutlet="virtualFileOffline"></ng-container>
								}
							} @else {
								<ng-container *ngTemplateOutlet="fileDownload"></ng-container>
							}
						} @else {
							<ng-container *ngTemplateOutlet="switchLanguage"></ng-container>
						}
					</div>
				} @else {
					<ng-container *ngTemplateOutlet="videoErrorMessage"></ng-container>
				}
			} @else {
				<ng-container *ngTemplateOutlet="fileNotFound"></ng-container>
			}

		</div>
	}
} @else {
	loading...
}


<ng-template #fileDownload>
	<div class="file-modal-noweb">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					@if(!isElectron()) {
						@if(!isADUser || !externalURL) {
							<p>{{'file_modal_noweb_intro_www'|translate:systemLanguage}}</p>
						}
						@if(isADUser && externalURL) {
							<p>{{'file_modal_noweb_intro_www_external'|translate:systemLanguage}}</p>
						}
						@if(!isElectron()) {
							<p>{{'file_modal_noweb_intro_www2'|translate:systemLanguage}}</p>
						}
					}

					@if(isElectron() && file) {
						@if(file.isInternalViewer()) {
							<p>{{'file_modal_noweb_intro'|translate:systemLanguage}}</p>
							@if(isElectron()) {
								<p>{{'file_modal_noweb_intro_electron'|translate:systemLanguage}}</p>
							}
						}
						@if(!file.isInternalViewer()) {
							<p>{{'file_modal_noweb_intro_external'|translate:systemLanguage}}</p>
							@if(isElectron()) {
								<p>{{'file_modal_noweb_intro_external2'|translate:systemLanguage}}</p>
							}
						}
					}

					<div>
						@if(isElectron()) {
							<button color="primary" mat-flat-button
								(click)="saveFile()">{{'save' | translate:systemLanguage}}</button>
							<button color="primary" mat-flat-button
								(click)="openFileElectron()">{{'open' | translate:systemLanguage}}</button>
						} @else {
							<button color="primary" mat-flat-button
								(click)="download()">{{'download' | translate:systemLanguage}}</button>
							@if(isADUser) {
								<iframe id="hiddenFrame" [src]="externalURL" style="visibility: hidden"></iframe>
							}
						}
					</div>
					<div class="closeModal">
						<a (click)="closeModal()">{{'close' | translate:systemLanguage}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>


<ng-template #switchLanguage>
	<div class="file-modal-noweb">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<p>{{'file_modal_translation'|translate:systemLanguage }}</p>
					<p><a [href]="webURL" target="_blank">Planerhandbuch.de</a></p>
					<div class="closeModal">
						<a (click)="closeModal()">{{'close' | translate:systemLanguage}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #virtualFileOffline>
	<div class="file-modal-noweb">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<p>{{'file_modal_virtual_file_offline'|translate:systemLanguage}}</p>
					<div class="closeModal">
						<a (click)="closeModal()">{{'close' | translate:systemLanguage}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #videoErrorMessage>
	<div class="file-modal-noweb file-modal-noweb--video">
		<div class="file-modal-noweb-inner">
			@if(file.previewHash) {
				<img [src]="file.previewHash | filePath" [alt]="file | caption:systemLanguage"
					style="width:100%; height:auto;"/>
			}

			<div class="video-description">
				<p>{{'file_modal_video_portal_offline'|translate:systemLanguage}}</p>
				<div class="closeModal">
					<a (click)="closeModal()">{{'close' | translate:systemLanguage}}</a>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #fileNotFound>
	<div class="file-modal-noweb file-modal-noweb--fileNotFound">
		<div class="file-modal-noweb-inner w-100">
			<div class="video-description ">
				<div>
					<h1>{{'file_modal_file_404_headline' | translate:systemLanguage}}</h1>
					<p>{{'file_modal_file_404_description' | translate:systemLanguage}}</p>
					<p><a [href]="webURL">{{'file_modal_file_404_open' | translate:systemLanguage}}</a>
					</p>
				</div>
				<div class="center" style="position:relative">
					<span class="preview-text">{{'file_modal_file_404_preview' | translate:systemLanguage}}</span>
					<img [src]="_node  | getIcon" width="300" [alt]="_node | caption:systemLanguage"/>
				</div>

				<div class="closeModal">
					<a (click)="closeModal()">{{'close' | translate:systemLanguage}}</a>
				</div>
			</div>

		</div>
	</div>
</ng-template>

